import { GridSortDirection } from "@mui/x-data-grid";

export interface Result<T> {
  data: T | null;
  readonly isSuccess: boolean;
  errors: string[];
  readonly statusCode: string | null;
}
export interface SortParameter {
  field: string;
  sort: GridSortDirection;
}

export class Result<T> {
  data: T | null;
  readonly isSuccess: boolean = true;
  errors: string[];
  readonly statusCode: string | null = "";

  constructor(result: Result<T>) {
    this.data = result.data;
    this.errors = result.errors;
  }
  static newResult = () =>
    new Result({ data: null, isSuccess: true, errors: [], statusCode: "" });
}

export interface PagedResponse<T> extends Result<Array<T>> {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalCount: number;
  readonly hasPrevious: boolean;
  readonly hasNext: boolean;
  sort?: SortParameter;
}
